import { render, staticRenderFns } from "./UploadInstaImage.vue?vue&type=template&id=cab64bb6&scoped=true&"
import script from "./UploadInstaImage.vue?vue&type=script&lang=js&"
export * from "./UploadInstaImage.vue?vue&type=script&lang=js&"
import style0 from "./UploadInstaImage.vue?vue&type=style&index=0&id=cab64bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab64bb6",
  null
  
)

export default component.exports